var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemperatur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#3a3a3a;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.86,37.13v-32A4.1,4.1,0,0,0,12.76,1H11.23A4.09,4.09,0,0,0,7.14,5.09v32A11,11,0,0,0,1,46.44,11.16,11.16,0,0,0,11.83,58a11,11,0,0,0,5-20.87Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.12,
    y1: 12.13,
    x2: 11.37,
    y2: 12.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.12,
    y1: 26.24,
    x2: 11.37,
    y2: 26.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.12,
    y1: 19.19,
    x2: 12.37,
    y2: 19.19
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatur);
export default __webpack_public_path__ + "static/media/Temperatur.a1d941686de63c9c7469171836ab84a3.svg";
export { ForwardRef as ReactComponent };